import { render, staticRenderFns } from "./brainCardiovascularInfoOld.vue?vue&type=template&id=2da95bd6"
import script from "./brainCardiovascularInfoOld.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularInfoOld.vue?vue&type=script&lang=js"
import style0 from "./brainCardiovascularInfoOld.vue?vue&type=style&index=0&id=2da95bd6&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da95bd6')) {
      api.createRecord('2da95bd6', component.options)
    } else {
      api.reload('2da95bd6', component.options)
    }
    module.hot.accept("./brainCardiovascularInfoOld.vue?vue&type=template&id=2da95bd6", function () {
      api.rerender('2da95bd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularInfoOld.vue"
export default component.exports